import Gd1 from "../../assets/Graphics1.png";
import Gd2 from "../../assets/Graphics2.png";
import Gd3 from "../../assets/Graphics3.png";
import Gd4 from "../../assets/Graphics4.png";
import Gd5 from "../../assets/Graphics5.png";
import Gd6 from "../../assets/Graphics6.png";
import Gd7 from "../../assets/Graphics7.png";
import Gd8 from "../../assets/Graphics8.png";
import Gd9 from "../../assets/Graphics9.png";
import Gd10 from "../../assets/Graphics10.png";
import Gd11 from "../../assets/Graphics11.png";
import Gd12 from "../../assets/Graphics12.png";

// import function to register Swiper custom elements
import { register } from "swiper/element/bundle";
import { Pagination } from "swiper/modules";
// register Swiper custom elements
register();

const GraphicDesignCarousel = () => {
  const items = [Gd1, Gd2, Gd3, Gd4, Gd5, Gd6, Gd7, Gd8, Gd9, Gd10, Gd11, Gd12];

  return (
    <div className="flex flex-col gap-y-5 w-full overflow-visible z-1">
      <div>
        <p className="italic animate-fade-down">(2021 - 2023)</p>
        <h1 className="text-5xl font-black animate-fade-up ">
          SELECTED PROJECTS
        </h1>
        <h1 className="text-xs sm:text-xl font-semibold animate-fade-up animate-once">
          Have a look at the projects we have worked on.
        </h1>
      </div>
      <div>
        <h1 className="italic font-bold">Graphic Design</h1>
      </div>
      <div className="">
        <swiper-container
          effect={"coverflow"}
          slides-per-view="3"
          speed="500"
          loop="true"
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="mySwiper"
        >
          {items.map((s, key) => (
            <swiper-slide>
              <img key={key} src={s} alt="img" className="object-cover" />
            </swiper-slide>
          ))}
        </swiper-container>
      </div>
    </div>
  );
};

export default GraphicDesignCarousel;
